import React from 'react';
import { useTranslation } from 'react-i18next';
import { Brain } from 'lucide-react';
import { useAIAgent } from '../contexts/AIAgentContext';

export default function AIAgentTriggerButton({ isLightTheme = false }) {
  const { t } = useTranslation();
  const p = (key) => t(`modules.shared.aiAgent.triggerButton.${key}`);
  const { isOpen, toggleAgent } = useAIAgent();

  const baseClass =
    'grid place-items-center w-9 h-9 p-0 border-none rounded-full cursor-pointer transition-colors duration-150';
  const themeClass = isLightTheme
    ? isOpen
      ? 'text-blue-600 bg-blue-500/10 shadow-[0_0_0_1px_rgba(96,165,250,0.35)]'
      : 'text-gray-600 bg-transparent hover:text-gray-900 hover:bg-gray-100'
    : isOpen
      ? 'text-blue-300 bg-blue-500/20 shadow-[0_0_0_1px_rgba(96,165,250,0.35)]'
      : 'text-white/80 bg-transparent hover:text-white hover:bg-white/10';

  return (
    <button
      type="button"
      onClick={toggleAgent}
      className={`${baseClass} ${themeClass}`}
      title={isOpen ? p('close_title') : p('open_title')}
      aria-label={isOpen ? p('close_aria') : p('open_aria')}
      aria-pressed={isOpen}
    >
      <Brain className="h-5 w-5" strokeWidth={1.75} />
    </button>
  );
}
